import Resource from '../../resource/Resource';
import { LTI_CONSUMER_RESOURCE } from '../resourceNames';

import {
  SET_LTI_PROVIDERS,
  SET_LTI_PROVIDER,
  DELETE_LTI_PROVIDER,
} from './actions';

import {
  FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE,
  FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS,
  FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_START,
  UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE,
} from '../InstitutionAdminUI/actions';

export function setLTIProviders(ltiProviders) {
  return (dispatch) => dispatch({ type: SET_LTI_PROVIDERS, ltiProviders });
}

export function deleteLTIProvider(id) {
  return (dispatch) => {
    return Resource.update('lti', id, 'deleteLTIProvider', {
      id,
    }).then((result) => {
      dispatch({
        type: DELETE_LTI_PROVIDER,
        result,
      });

      return result;
    });
  };
}

export function saveLTIProvider(data) {
  return (dispatch) => {
    return Resource.update('lti', data._id, 'updateLTIProvider', {
      ltiData: data,
    }).then((result) => {
      dispatch({
        type: SET_LTI_PROVIDER,
        result,
      });

      return result;
    });
  };
}

export function createLTIProvider(institutionName, data) {
  return (dispatch) => {
    const processedData = Object.assign({}, data);
    processedData.institution = institutionName;

    return Resource.execute('lti', 'createLTIProvider', {
      ltiData: processedData,
    }).then((result) => {
      dispatch({
        type: SET_LTI_PROVIDER,
        result,
      });

      return result;
    });
  };
}

export function fetchLTIConsumerCohortsContextIds(institutionPath, coursePath) {
  return (dispatch) => {
    const ltiConsumerKey = `institution:${institutionPath}`;
    dispatch({
      type: FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_START,
      institutionPath,
      coursePath,
    });
    Resource.lookup(LTI_CONSUMER_RESOURCE, 'getCourseCohortsContextIds', {
      lti_consumer_key: ltiConsumerKey,
      course_path: coursePath.toLowerCase(),
    }).then(
      (data) => {
        dispatch({
          type: FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS,
          institutionPath,
          coursePath,
          contextIdsByCohort: data.cohorts,
          courses: [data.course],
        });
      },
      (error) => {
        dispatch({
          type: FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE,
          institutionPath,
          coursePath,
          error,
        });
      }
    );
  };
}

export function updateCourseCohortContextIds(
  institutionPath,
  coursePath,
  contextIdsByCohort
) {
  return (dispatch) => {
    const ltiConsumerKey = `institution:${institutionPath}`;
    Resource.execute(
      LTI_CONSUMER_RESOURCE,
      'update_course_linking_context_ids',
      {
        lti_consumer_key: ltiConsumerKey,
        course_path: coursePath.toLowerCase(),
        new_context_ids: contextIdsByCohort.toJS(),
      }
    ).then(
      () => {},
      (error) => {
        dispatch({
          type: UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE,
          institutionPath,
          coursePath,
          error,
        });
      }
    );
  };
}
